import * as React from "react";
import * as classNames from "classNames";

export interface ISpinnerProps extends React.Props<Spinner> {
    cssWrapper?: string;
    message?: string | JSX.Element;
    isLoading?: boolean;
    notFull?: boolean;
}

export interface ISpinnerState {}

export class Spinner extends React.Component<ISpinnerProps, ISpinnerState> {
    constructor(props: ISpinnerProps) {
        super(props);

        this.state = {};
    }

    public render(): JSX.Element {
        const { cssWrapper, message, children } = this.props;
        const { isLoading, notFull } = this.props;

        const messageElement = message ? <div className="spinner-message">{message}</div> : null;
        const CSS = classNames("spinner", cssWrapper);
        const wrapCSS = classNames("spinner-wrap", notFull ? null : "is-fullscreen");

        return isLoading || isLoading == undefined ? (
            <div className={wrapCSS}>
                <div className={CSS}>
                    <div className="spinner-inner" role="status">
                        <span className="sr-only">Loading...</span>
                        <div className="spinner-icon"></div>
                    </div>
                    {messageElement}
                </div>
            </div>
        ) : (
            <div>{children}</div>
        );
    }
}
